import { render, staticRenderFns } from "./VDealLogbook.vue?vue&type=template&id=68306fa8"
import script from "./VDealLogbook.vue?vue&type=script&lang=js"
export * from "./VDealLogbook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports